import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

export const apiFetchMemberPoolStorages = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getMemberPoolStorages',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, {
    operators: payload.params,
  });
};

export const apiEditMemberPoolStorage = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'createTrayPoolModificationTransaction',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.post(serviceUrl, {
    operator: payload.params.operator,
    palletCapacity: payload.params.palletCapacity,
    trayCapacity: payload.params.trayCapacity,
  });
};
